'use client'

import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { Folder } from 'lucide-react'
import { lazy, Suspense } from 'react'

const ProjectsTableCard = lazy(() => import('@/components/ui/projects-table-card').then(mod => ({ default: mod.ProjectsTableCard })))

interface ProjectsWidgetProps {
  title: string
  projects: any[]
  loading?: boolean
}

export function ProjectsWidget({ title, projects, loading }: ProjectsWidgetProps) {
  return (
    <Suspense fallback={<Card><CardContent className="p-6"><Skeleton className="h-64 w-full" /></CardContent></Card>}>
      <ProjectsTableCard
        title={title}
        icon={Folder}
        projects={projects}
        loading={loading}
        maxItems={5}
        showViewAll={true}
        viewAllHref="/projects"
      />
    </Suspense>
  )
}
